import React, { useState, useEffect } from "react";
import "./Articles.css";
import axios from "axios";
import swal from "sweetalert";
import Header from "../../Hoc/Header";
import Footer from "../../Hoc/Footer";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import moment from "jalali-moment";
import styles from "./Article.module.scss";
import { RiCalendar2Line } from "react-icons/ri";
import { BsChatLeftText } from "react-icons/bs";
import { useParams } from "react-router-dom";

function ArticleSingle() {
  const { post_id } = useParams();

  const [comment, setComment] = useState("");
  const [user, setUser] = useState(null);
  const [articleData, setArticleData] = useState(null);
  const [comments, setComments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getUser();
    getArticleData();
    getComments();
  }, [post_id]);

  const getUser = () => {
    axios
      .get(
        `https://arianaapp.arianaapply.com/api/V1/get-user/${localStorage.getItem(
          "token"
        )}`
      )
      .then((response) => {
        setUser(response.data);
      })
      .catch((err) => console.log(err));
  };

  const getArticleData = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-news/${post_id}`)
      .then((response) => {
        setArticleData(response.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const getComments = () => {
    axios
      .get(`https://arianaapp.arianaapply.com/api/V1/get-comments/${post_id}`)
      .then((res) => {
        setComments(res.data || []);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postComment = () => {
    if (!comment.trim()) {
      swal({
        title: "!خطا",
        text: "!شما دیدگاهی پر نکردید",
        icon: "error",
        button: "!باشه",
      });
      return;
    }

    if (!user?._id) {
      swal({
        title: "!خطا",
        text: "لطفا ابتدا وارد حساب کاربری خود شوید",
        icon: "error",
        button: "!باشه",
      });
      return;
    }

    axios
      .post(`https://arianaapp.arianaapply.com/api/V1/comment-submit`, {
        comment: comment,
        post_id: post_id,
        user_id: user._id,
      })
      .then((response) => {
        console.log(response);
        swal({
          title: "!ارسال شد",
          text: "! دیدگاه شما با موفقیت ارسال شد",
          icon: "success",
          button: "!باشه",
        });
        setComment("");
        getComments(); // رفرش لیست کامنت‌ها
      })
      .catch((error) => {
        console.log(error);
        swal({
          title: "!ارسال نشد",
          text: "!دیدگاه شما ثبت نشد",
          icon: "error",
          button: "!باشه",
        });
      });
  };

  if (loading || !articleData) {
    return (
      <div className="spinner">
        <Loader
          type="TailSpin"
          color="rgb(236, 177, 28)"
          height={80}
          width={80}
        />
      </div>
    );
  }

  return (
    <div className={styles.singleArticle}>
      <Header title="مقاله" />

      <div className={styles.singleArticleBody}>
        <div className="article-img-box">
          <img
            className="article-img"
            src={articleData.img?.url}
            alt={articleData.title || ""}
          />
        </div>

        <div className={styles.singleArticleBodyText}>
          <div className={styles.singleArticleTextDateComment}>
            <span className="opasity">
              <RiCalendar2Line />
              {articleData.created_at
                ? moment(articleData.created_at, "YYYY/MM/DD")
                    .locale("fa")
                    .format("YYYY/MM/DD")
                : ""}
            </span>
            <span className="opasity">
              <BsChatLeftText /> {comments.length} دیدگاه
            </span>
          </div>

          <h4>{articleData.title}</h4>
          <p>{articleData.content}</p>
        </div>
      </div>

      <div className="comment-inp">
        <h2>ثبت دیدگاه</h2>

        <input
          type="text"
          name="comment"
          placeholder="دیدگاه خود را برای ما بنویسید..."
          onChange={(e) => setComment(e.target.value)}
          value={comment}
        />

        <button onClick={postComment}>ثبت</button>
      </div>

      <div className="comment">
        <h2>دیدگاه ها</h2>

        <div className="comment-boxes">
          {comments.length > 0 ? (
            comments.map((item) => (
              <div className="comment-box" key={item._id}>
                <h3>{item.user?.name || "کاربر"}</h3>
                <p>{item.comment}</p>
              </div>
            ))
          ) : (
            <div className="comment-box-pc">
              <p>هنوز دیدگاهی ثبت نشده است</p>
            </div>
          )}
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default ArticleSingle;